import React, { useRef } from 'react';

const allowed = new Set(['P','DIV','BR','STRONG','B','EM','I','U','UL','OL','LI','BLOCKQUOTE']);
const blocked = new Set(['SCRIPT','STYLE','IFRAME','OBJECT','SVG','MATH']);
export function contentText(body = '', format = 'plain') {
  if (format !== 'html') return body;
  return new DOMParser().parseFromString(body, 'text/html').body.textContent || '';
}
export function ForumContent({ body = '', format = 'plain' }) {
  if (format !== 'html') return <p className="whitespace-pre-wrap break-words leading-relaxed">{body}</p>;
  const doc = new DOMParser().parseFromString(body, 'text/html');
  function render(node, key) {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1 || blocked.has(node.tagName)) return null;
    const children = Array.from(node.childNodes).map((child, i) => render(child, i));
    if (!allowed.has(node.tagName)) return <React.Fragment key={key}>{children}</React.Fragment>;
    const tag = node.tagName.toLowerCase();
    return React.createElement(tag, { key, className: tag === 'ul' ? 'list-disc pl-6' : tag === 'ol' ? 'list-decimal pl-6' : undefined }, tag === 'br' ? undefined : children);
  }
  return <div className="break-words leading-relaxed space-y-2">{Array.from(doc.body.childNodes).map(render)}</div>;
}

export default function ForumRichText({ label, onChange, labels }) {
  const editor = useRef(null);
  function command(action, value) {
    editor.current.focus();
    document.execCommand(action, false, value);
    onChange(editor.current.innerHTML);
  }
  const tools = [['bold', 'B', labels.bold], ['italic', 'I', labels.italic], ['underline', 'U', labels.underline], ['insertUnorderedList', '•', labels.list], ['insertOrderedList', '1.', labels.numbered]];
  return <div className="grid gap-2">
    <span id="forum-editor-label">{label}</span>
    <div className="border border-base-300 rounded-box overflow-hidden">
      <div role="toolbar" aria-label={labels.formatting} className="flex flex-wrap items-center gap-1 bg-base-200 p-2 border-b border-base-300">
        {tools.map(([action, text, name]) => <button type="button" className="btn btn-sm" key={action} aria-label={name} title={name} onMouseDown={e => e.preventDefault()} onClick={() => command(action)}>{text}</button>)}
        {['😊','🙏','❤️','✨','👍','🤔','🍀','💬'].map(emoji => <button type="button" className="btn btn-sm" key={emoji} aria-label={`${labels.emoji} ${emoji}`} onMouseDown={e => e.preventDefault()} onClick={() => command('insertText', emoji)}>{emoji}</button>)}
      </div>
      <div ref={editor} role="textbox" aria-labelledby="forum-editor-label" aria-multiline="true" contentEditable suppressContentEditableWarning className="min-h-64 p-4 outline-none focus:ring-2 focus:ring-base-300 leading-relaxed [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-6 [&_ol]:pl-6" onInput={() => onChange(editor.current.innerHTML)} onPaste={e => { e.preventDefault(); command('insertText', e.clipboardData.getData('text/plain')); }} />
    </div>
  </div>;
}
